// extracted by mini-css-extract-plugin
export default {"tasks":"WO-z","task":"XO-z","svg":"YO-z","text":"ZO-z"};